import { Button, TextField, Grid, Paper, Container, TextareaAutosize, Input } from '@mui/material';
import { useEffect, useState } from 'react';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RichTextComponent from '../RichTextComponent';
import PostImageUploadComponent from './PostImageUploadComponent';
import VideoUploadComponent from './VideoComponent';
import AudioUploadComponent from './AudioUploadComponent';
import VideoRecorder from './videoRecord';
import axios from 'axios';
import { decrypt, encrypt } from '../../../Security';

function Post({ post, removePosts, posts, setPosts, index, repId, adding, setAddedData, handleDelete }) {
    const [_id, setId] = useState('');
    const [title, setTitle] = useState('');
    const [detail, setDetail] = useState('');
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectedVideos, setSelectedVideos] = useState([]);
    const [selectedAudios, setSelectedAudios] = useState([]);

    // useEffect(() => {
    //     console.log("init in Post.jsx", post);
    // }, []);

    const handleRemovePost = () => {
        removePosts(post);
    };


    const handleDeleteImageUpload=async(url)=>{
        if(adding){
            handleDelete(url)
        }
        else
        {
            // updatePost()
        }
    }
  

    const updatePost=async()=>{
        try{
            console.log("going to update post",{
                title,detail,videoPaths:selectedVideos,imagePaths:selectedImages,audioPaths:selectedAudios
            })
            const url = process.env.REACT_APP_PUBLIC_SERVER_URI + '/api/v1/repFeeds'
            const response = await fetch(url, {
                method: 'PATCH',
                headers: {
                  'Content-Type': 'application/json' // Specify Content-Type header
                },
                credentials:'include',
                body:encrypt({
                    feed_id:post._id,title,detail,videoPaths:selectedVideos,imagePaths:selectedImages,audioPaths:selectedAudios
                })
              });
            
              let data = decrypt(await response.json()); // Parse response as JSON
              if (data.msg=="SUCCESS") { 
                  alert('Posts Updated successfully!')
                   
              }
              else {
                // console('Error while fetching feeds..'+ data.msg)
                alert('Erorr while updating Post: '+data.msg)
              }
        }
        catch(err){
            alert(err)
            
        }
    }

    useEffect(() => {
        // console.log("Images-2: ",post?.imagePaths)
        // console.log("videos-2: ",post?.videoPaths)
        // console.log("audios-2: ",post?.audioPaths)

        // console.log("POST", post);
        setId(post?._id || '');
        setTitle(post?.title || '');
        setDetail(post?.detail || '');
        setSelectedImages(post?.imagePaths ? post.imagePaths.map(path => process.env.REACT_APP_PUBLIC_SERVER_URI + path) : []);
        setSelectedVideos(post?.videoPaths ? post.videoPaths.map(path => process.env.REACT_APP_PUBLIC_SERVER_URI + path) : []);
        setSelectedAudios(post?.audioPaths ? post.audioPaths.map(path => process.env.REACT_APP_PUBLIC_SERVER_URI + path) : []);
    }, [post]);
    useEffect(() => {
        // console.log("Images1: ",selectedVideos)
        // console.log("videos1: ",selectedVideos)
        if (adding) {
            setAddedData({
               
                'title': title,
                'detail': detail,
                'imagePaths': selectedImages.map(image => image.replace(process.env.REACT_APP_PUBLIC_SERVER_URI, '')),
                'videoPaths': selectedVideos.map(video => video.url.replace(process.env.REACT_APP_PUBLIC_SERVER_URI, '')),
                'audioPaths': selectedAudios.map(image => image.replace(process.env.REACT_APP_PUBLIC_SERVER_URI, ''))
            });
        }
    }, [title, detail, selectedImages, selectedVideos, selectedAudios]);
    

    return (
        <Grid container sx={{ paddingLeft: { xs: 2, md: 3 }, paddingRight: { xs: 2, md: 3 }, paddingBottom: { xs: 2, md: 3 } }} >
            {!adding &&
                <Grid item xs={12} >
                    <Button onClick={handleRemovePost} sx={{ float: 'right' }}> 
                        <HighlightOffIcon style={{ color: 'red', fontSize: 25, }} />
                    </Button>
                </Grid>}
            <Grid item xs={12}>
                <TextField
                    variant="outlined"
                    required
                    fullWidth
                    style={{ marginTop: '30px' }}
                    id="title"
                    label="Title"
                    name="title"
                    autoComplete="title"
                    value={title}
                    onChange={(event) => setTitle(event.target.value)}
                />
            </Grid>
            <Grid item xs={12} sx={{ mt: 2 }}>
                <RichTextComponent textInput={detail} setTextInput={setDetail} title={'Details'} />
            </Grid>
            <Grid item xs={12} sx={{ mt: 2 }}>
                <PostImageUploadComponent 
                    createMode={adding} 
                    uploadedImages={selectedImages} 
                    handleDeleteUpload={handleDeleteImageUpload} 
                    setUploadedImages={setSelectedImages} 
                />
            </Grid>
            <Grid item xs={12} sx={{ mt: 2 }}>
                <VideoUploadComponent 
                    createMode={adding} 
                    videos={selectedVideos} 
                    handleDeleteUpload={handleDelete} 
                    setVideos={setSelectedVideos} 
                />
            </Grid>
            <Grid item xs={12} sx={{ mt: 2 }}>
                <AudioUploadComponent createMode={adding} uploadedFiles={selectedAudios} handleDeleteUpload={handleDelete} setUploadedFiles={setSelectedAudios} />
            </Grid>
            {!adding && <Button onClick={updatePost} variant="contained" color="primary" size="large" style={{ marginTop: '20px', backgroundColor: '#007bff', color: 'white', fontWeight: 'bold' }}>Update Post</Button>}
        </Grid>
    );
}

export default Post;